import styled, { css } from 'styled-components'

// Utils
import { breakpoint } from 'utils/breakpoint'

export const Title = styled.p<{ small?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.body};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin: ${({ small }) => (small ? '0px' : '16px 0 16px 0')};

  ${({ small }) =>
    small &&
    css`
      ${breakpoint('base', 'sm')`
        display: none;
      `}
    `};
`

export const Description = styled.p<{ small?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  margin: ${({ small }) => (small ? '0px' : '16px 0 16px 0')};
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};

  ${({ small }) =>
    small &&
    css`
      ${breakpoint('base', 'sm')`
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
      `}
    `};
`

export const IconContainer = styled.div<{ small?: boolean }>`
  display: inline-block;
  max-width: ${({ small }) => (small ? '40px' : '48px')};
  min-width: ${({ small }) => (small ? '40px' : '48px')};
  max-height: ${({ small }) => (small ? '40px' : '48px')};
  min-height: ${({ small }) => (small ? '40px' : '48px')};
  margin-right: ${({ small }) => (small ? '8px' : '0')};
`

export const ActionContainer = styled.div<{ small?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  justify-content: flex-end;

  ${({ small }) =>
    small &&
    css`
      flex: 0 0 auto;
      align-self: center;
      align-items: flex-end;
    `};
`

export const Wrapper = styled.div<{ small?: boolean }>`
  ${({ theme, small }) => css`
    position: relative;
    display: flex;
    flex-direction: ${small ? 'row' : 'column'};
    width: 100%;
    min-width: 220px;
    padding: ${small ? '12px 16px' : '24px'};
    border: 1px solid ${theme.colors.border[1]};
    border-radius: ${theme.radii.large};
    flex: 1 1 45%;

    :hover {
      ${Dismiss} {
        opacity: 1;
      }
    }

    ${ActionContainer} {
      flex: 1;
    }

    ${breakpoint('base', 'xs')`
      flex-direction: row;
      flex: 0;

      ${Title}{
        margin-top: 0px;
        margin-bottom: 5px;
      }

      ${Description}{
        margin-top: 0px;
      }

      ${IconContainer}{
        margin-right: 12px;
      }
    `}
  `}
`

export const Action = styled.div<{ small?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-left: 4px;

  ${({ small }) =>
    small &&
    css`
      ${breakpoint('base', 'sm')`
        display: none;
      `}
    `};
`

export const Dismiss = styled.button<{ small?: boolean }>`
  position: absolute;
  top: -11px;
  right: -11px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  padding: 4px;
  background: ${({ theme }) => theme.colors.background.secondary[1]};
  border: 1px solid ${({ theme }) => theme.colors.border[1]};
  border-radius: 100%;
  opacity: 0;
  transition: opacity 300ms ease-in-out;
  cursor: pointer;

  ${({ small }) =>
    small &&
    css`
      ${breakpoint('base', 'sm')`
          position: relative;
          top: auto;
          right: auto;
          opacity: 1;
        `};
    `};
`
